import { isBlacklistedCreator } from '@/lib/createGuard'

/**
 * Permanently hide specific on-chain listings from Penguin Pad discovery
 * without wiping the rest of the live slate.
 *
 * Hidden:
 * - BABY $PENGUIN$ at 0x154E54B2a23da3f78a3F31bd6242666834b8e266
 *   (share slug BABYPENGUIN1). The 0.9 ETH BABY $PENGUIN$ listing stays visible.
 * - PAD / $PAD impersonation listings, matched by name, ticker, slug, or the PAD creator wallet.
 */
const HIDDEN_ADDRESSES = new Set([
  '0x154e54b2a23da3f78a3f31bd6242666834b8e266',
])

const HIDDEN_SLUGS = new Set([
  'babypenguin1',
  'pad',
])

const HIDDEN_TICKERS = new Set([
  'PAD',
])

function normalizeAddress(value?: string | null): string {
  return value?.trim().toLowerCase() || ''
}

function compactName(value?: string | null): string {
  return value?.trim().toLowerCase().replace(/[^a-z0-9]/g, '') || ''
}

function compactTicker(value?: string | null): string {
  return value?.trim().toUpperCase().replace(/^\$+/, '') || ''
}

function matchesHiddenAddress(value?: string | null): boolean {
  const address = normalizeAddress(value)
  return Boolean(address) && HIDDEN_ADDRESSES.has(address)
}

function matchesHiddenBrand(item?: {
  name?: string
  ticker?: string
  shareSlug?: string
} | null): boolean {
  if (!item)
    return false
  const slug = item.shareSlug?.trim().toLowerCase()
  if (slug && HIDDEN_SLUGS.has(slug))
    return true
  const ticker = compactTicker(item.ticker)
  if (ticker && HIDDEN_TICKERS.has(ticker))
    return true
  return compactName(item.name) === 'pad'
}

export function isHiddenListingAddress(value?: string | null): boolean {
  return matchesHiddenAddress(value)
}

export function isHiddenLaunch(item?: {
  id?: string
  name?: string
  ticker?: string
  contractAddress?: string
  tokenAddress?: string
  shareSlug?: string
  creatorAddress?: string
} | null): boolean {
  if (!item)
    return false
  if (matchesHiddenBrand(item) || isBlacklistedCreator(item.creatorAddress))
    return true
  return matchesHiddenAddress(item.contractAddress)
    || matchesHiddenAddress(item.tokenAddress)
    || matchesHiddenAddress(item.id)
}
